import React, { useContext } from 'react';
import { useInterval } from 'usehooks-ts';
import dayjs from 'dayjs';
import { useState } from 'react';
import { MAINTENANCE_CONFIG } from '../configs/maintenanceConfig';
import { APP_STAGE, AppStage } from '@cmctechnology/webinvest-constants';
import Cookies from 'js-cookie';

const showMaintenanceQueryParam = 'showMaintenance';
const showBannerQueryParam = 'showBanner';

const showMaintenanceOverride = (): boolean | undefined => {
  const maintenanceCookie = Cookies.get(showMaintenanceQueryParam);
  if (maintenanceCookie === 'true') return true;
  const isProd = (process.env.REACT_APP_STAGE as AppStage) === APP_STAGE.Prod;
  if (!isProd) return false;
  if (maintenanceCookie === 'false') return false;
};

const showBannerOverride = (): boolean | undefined => {
  const bannerCookie = Cookies.get(showBannerQueryParam);
  if (bannerCookie === 'true') return true;
  if (bannerCookie === 'false') return false;
};

const checkTime = () => {
  const now = dayjs();
  const { preStartTime, startTime, endTime } = MAINTENANCE_CONFIG;
  const maintenanceOverride = showMaintenanceOverride();
  const bannerOverride = showBannerOverride();
  const isTimeToShowMaintenance = now.isAfter(dayjs(startTime)) && now.isBefore(dayjs(endTime));
  return {
    showMaintenanceBanner: bannerOverride === true || (now.isAfter(dayjs(preStartTime)) && now.isBefore(dayjs(startTime)) && bannerOverride !== false),
    showMaintenancePage: maintenanceOverride === true || (isTimeToShowMaintenance && maintenanceOverride !== false),
    beforePreMaintenanceTime: now.isBefore(dayjs(preStartTime)),
    afterMaintenanceTime: now.isAfter(dayjs(endTime))
  };
};

const DELAY = 60_000;

export const useMaintenanceInterval = () => {
  const [showMaintenance, setShowMaintenance] = useState(checkTime());

  useInterval(
    () => {
      setShowMaintenance(checkTime());
    },
    // eslint-disable-next-line unicorn/no-null
    showMaintenance.afterMaintenanceTime ? null : DELAY
  );

  return showMaintenance;
};

export type IMaintenanceContextProps = Partial<ReturnType<typeof checkTime>>;

export const MaintenanceContext = React.createContext<IMaintenanceContextProps>({});

export const useMaintenance = () => useContext(MaintenanceContext);

export const MaintenanceProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const maintenance = useMaintenanceInterval();
  return <MaintenanceContext.Provider value={maintenance}>{children}</MaintenanceContext.Provider>;
};
